import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const disableAbTestGroupUser = async (abTestName: string, associatedObjectId: string) => {
  const response = await mutationExecute({
    variables: { abTestName, associatedObjectId },
    mutation: graphql(`
      mutation disableAbTestGroupUser($abTestName: String!, $associatedObjectId: String!) {
        disableAbTestGroupUser(abTestName: $abTestName, associatedObjectId: $associatedObjectId)
      }
    `),
  });

  if (!response.data?.disableAbTestGroupUser) {
    throw new Error('Unexpected empty response');
  }

  return response.data.disableAbTestGroupUser;
};
